import { BehaviorSubject } from 'rxjs';
import { addError } from './Error';
import { getChartsData } from '../Api/Asset/AssetApi';

export interface ChartData {
  id: string;
  label: string;
  value: string | number;
  email?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ChartsData {
  openBnCValue: ChartData[];
  overdueFollowUp: ChartData[];
  overdueTicket: ChartData[];
  validationNeeded: ChartData[];
  missingLink: ChartData[];
  disconnectedNotDecommissioned: ChartData[];
  originalStillCommissioning: ChartData[];
  openBnCByAP: ChartData[];
  openBnCByMonth: ChartData[];
  originalAndRenewalOverlap: ChartData[];
}

const chartsDataSubject = new BehaviorSubject<ChartsData | null>(null);

const clearError = () => addError('charts', undefined);

export const getChartsDataSubject = (): BehaviorSubject<ChartsData | null> => chartsDataSubject;

export const fetchChartsData = async (): Promise<void> => {
  const { data, error } = await getChartsData();
  if (data) {
    clearError();
    chartsDataSubject.next(data);
  }
  if (error) addError('charts', error.message);
};
